export default __webpack_public_path__ + "static/media/Slide10.0908bb66.JPG";